import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faChampagneGlasses } from "@fortawesome/free-solid-svg-icons";

const salonesCol1 = [
  {
    nombre: "A.T.S.A",
    link: "https://maps.app.goo.gl/1si9m6wCydfLQmvd7",
    direccion: <>Leandro N.Alem.</>,
  },
  {
    nombre: "Casualidad Eventos",
    link: "https://maps.app.goo.gl/NmFbjEV5VC1z2RQ79",
    direccion: <>Ruta Nº10 – Km 1-2.</>,
  },
  {
    nombre: "Club de Cazadores y pescadores",
    link: "https://maps.app.goo.gl/4ABPqavV5Sff8J58A",
    direccion: <>Ruta Nº10 – Km 3.</>,
  },
  {
    nombre: "Centro de Jubilados y Pensionados Nacionales",
    link: "https://maps.app.goo.gl/1v699yQ6JTwnq5vs6",
    direccion: <>Esquina Bv. Rodolfo Moyano y Mariano Moreno.</>,
  },
  {
    nombre: "Club de Abuelos de Oliva",
    link: "https://maps.app.goo.gl/8cuHY413bJSQ8ez39",
    direccion: <>Bv. Rodolfo Moyano 647.</>,
  },
  {
    nombre: "Centro Vecinal Medalla Milagrosa",
    link: "https://maps.app.goo.gl/EErb2GD6YbSg4hp18",
    direccion: <>Esquina José Artigas y Sarmiento.</>,
  },
  {
    nombre: "Centro Vecinal San Cayetano",
    link: "#",
    direccion: <>25 de mayo 357.</>,
  },
  {
    nombre: "Centro Vecinal Centro Norte",
    link: "#",
    direccion: <>Belgrano 51.</>,
  },
];

const salonesCol2 = [
  {
    nombre: "Circulo Católico de Obreros San José",
    link: "https://maps.app.goo.gl/KRQm93JiVLD1ZUwF8",
    direccion: <>Chubut 766.</>,
  },
  {
    nombre: "Sociedad Rural de Oliva",
    link: "https://maps.app.goo.gl/YLzjiSEstgrHyPUR6",
    direccion: <>Esquina La Rioja y Francia.</>,
  },
  {
    nombre: "Polideportivo Club Atlético Vélez Sarsfield",
    link: "https://maps.app.goo.gl/tBQyddRMJufKkCHVA",
    direccion: <>Av. Emilio Olmos.</>,
  },
  {
    nombre: "Salón Social Club Atlético Vélez Sarsfield",
    link: "https://maps.app.goo.gl/K9JeVmdrARahGvu26",
    direccion: <>Av. Olmos.</>,
  },
  {
    nombre: "Jaranha Eventos",
    link: "https://maps.app.goo.gl/RZwkVNwZ6Kk3hNMZ8",
    direccion: <>Güemes 735.</>,
  },
  {
    nombre: "Salón de Fiesta el Ruedo",
    link: "https://maps.app.goo.gl/Au3kVwtEbHnywA3Y8",
    direccion: <>Patricias Argentinas.</>,
  },
  {
    nombre: "Salón de Evento 247",
    link: "https://maps.app.goo.gl/Au3kVwtEbHnywA3Y8",
    direccion: (
      <>
        Colón 15.<br />
        03532 - 15417983
      </>
    ),
  },
  {
    nombre: "Salón VIP C.A.V.S",
    link: "https://maps.app.goo.gl/dwPdgsMzBvNnN3pZ7",
    direccion: (
      <>
        Av. Olmos (Club Atlético Velez Sarsfield).<br />
      </>
    ),
  },
];

const SalonesFiestas = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={faChampagneGlasses} style={{ color: "#c0392b", marginRight: 8 }} />
          Salones de Fiestas
        </h5>
        <ul className="lista-referencias">
          {salonesCol1.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-6">
        <ul className="lista-referencias" style={{ marginTop: 38 }}>
          {salonesCol2.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default SalonesFiestas;